import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {ruRU as pickersRuRU, enUS as pickersEnUS} from '@mui/x-date-pickers/locales';

import i18n from 'i18n';

export const DynamicLocalizationProvider = ({children}: {children: React.ReactNode}) => {
    const currentLanguage = i18n.language;

    // Преобразуем язык из i18n в формат, который понимает dayjs
    const getDayJsLocale = (lng: string) => {
        switch (lng) {
            case 'ru':
                return 'ru-RU';
            case 'en':
                return 'en-US';
            default:
                return 'ru_RU'; // Язык по умолчанию
        }
    };

    const dayJsLocale = getDayJsLocale(currentLanguage);

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={dayJsLocale}
            localeText={
                i18n.language === 'ru'
                    ? pickersRuRU.components.MuiLocalizationProvider.defaultProps.localeText
                    : pickersEnUS.components.MuiLocalizationProvider.defaultProps.localeText
            }
        >
            {children}
        </LocalizationProvider>
    );
};
